import isNull from 'lodash/isNull';
import { showError } from '../../../common/A1Alert/A1Alert';
import Api from '../../../helpers/Api';

// Check the documentation (readme.txt) for more information...

// ACTION  TYPE

export const SET_CHECKED_RESERVED_PRIZE = 'SET_CHECKED_RESERVED_PRIZE';
const setCheckedReservedPrize = (checkedReservedPrize) => ({
    type: SET_CHECKED_RESERVED_PRIZE,
    checkedReservedPrize,
});

export const SET_IF_HAS_ACTIVE_HUNT = 'SET_IF_HAS_ACTIVE_HUNT';
const setIfHasActiveHunt = (hasActiveHunt) => ({
    type: SET_IF_HAS_ACTIVE_HUNT,
    hasActiveHunt,
});

export const SET_USER_WON_PREMIO = 'SET_USER_WON_PREMIO';
const setUserWonPrize = (prizeWon) => ({
    type: SET_USER_WON_PREMIO,
    prizeWon,
});

export const SET_SHOW_MODAL = 'SET_SHOW_MODAL';

export const setShowModal = (showModal) => ({
    type: SET_SHOW_MODAL,
    showModal,
});

export const SET_SHOW_SIGN = 'SET_SHOW_SIGN';

export const setShowSign = (showSign) => ({
    type: SET_SHOW_SIGN,
    showSign,
});

// ACTION

// This function verify if user is logged
// if exists active caca ao tesouro promotion
// If caca ao tesouro promotion is in your city or state or  national.

// TODO rewrite the complete caca ao tesouro! The globalcheck stuff should be joined with the normal caca ao tesouro stuff
// It is very confuse...

export const validateIfHasActiveTesouro = () => (dispatch, getState) => {
    // if still not defined hasActiveHunt
    const state = getState();
    const { huntAllInfos } = state.cacaAoTesouro;
    const { hasActiveHunt } = state.cacaAoTesouroGlobalCheck;

    if (huntAllInfos.idHunt && isNull(hasActiveHunt)) {
        const token = state.profile.jwt;
        const registrationComplete = state.profile.user.registrationComplete;

        // Step 1 - if user is not logged  or is logged but register is not complete
        // keep state "hasActiveHunt" as  null to not call api
        if (!token || !registrationComplete) {
            return Promise.resolve(1);
        }

        const query = '/api/v1/cacaAoTesouro/checkHuntAndPrizes';

        return Api.post(query, {}, token)
            .then((json) => {
                if (json.status === 'success' && isNull(json.data)) {
                    // if does't has  hunt and prizes to user, set  "false" to  state "hasActiveHunt"
                    return dispatch(setIfHasActiveHunt(false));
                }

                if (json.status === 'success' && json.data) {
                    return dispatch(setIfHasActiveHunt(json.data));
                }

                throw `error from server: ${json.message}`;
            }).catch((error) => {
                throw `validateIfHasActiveTesouro got error:${error}`;
            });
    }

    return Promise.resolve(1);
};


export const checkSomeReservedPrize = () => (dispatch, getState) => {
    // check for some reserved promotion of user if there is an active hunt, the user is logged in and it was not yet checked
    const state = getState();
    const token = state.profile.jwt;
    const { checkedReservedPrize } = state.cacaAoTesouroGlobalCheck;
    const { huntAllInfos } = state.cacaAoTesouro;

    if (huntAllInfos.idHunt && token && !checkedReservedPrize) {
        const query = '/api/v1/cacaAoTesouro/checkSomeReservedPrize';

        return Api.post(query, {}, token)
            .then((json) => {
                if (json.status === 'success' && isNull(json.data)) {
                    const allPromises = [
                        dispatch(setCheckedReservedPrize(true)),
                        dispatch(validateIfHasActiveTesouro()),
                    ];

                    return Promise.all(allPromises);
                }

                if (json.status === 'success' && json.data) {
                    // has reserved prize
                    return dispatch(setUserWonPrize(json.data));
                }

                throw `error from server: ${json.message}`;
            }).catch((error) => {
                throw `checkSomeReservedPrize got error:${error}`;
            });
    }

    return Promise.resolve(1);
};

export const setPageViewAndCheckWin = () => (dispatch, getState) => {
    const token = getState().profile.jwt;
    const query = '/api/v1/cacaAoTesouro/setPageViewAndCheckWin';

    return Api.post(query, {}, token)
        .then((json) => {
            if (isNull(json.data)) {
                return Promise.resolve(1);
            }

            return dispatch(setUserWonPrize(json.data));
        }).catch((error) => {
            throw `setPageViewAndCheckWin got error:${error}`;
        });
};


export const changeLogStatusAndSendMail = () => (dispatch, getState) => {
    const token = getState().profile.jwt;
    const query = '/api/v1/cacaAoTesouro/changeLogStatusAndSendMail';

    return Api.post(query, {}, token)
        .then((json) => {
            if (json.status === 'success') {
                const myPromises = [
                    dispatch(setShowModal(json.data)),
                    dispatch(setUserWonPrize(false)),
                ];

                return Promise.all(myPromises);
            }

            showError('Ocorreu um erro inesperado! Por favor tente novamente clicando no baú.');

            throw `error from server: ${json.message}`;
        }).catch((error) => {
            throw `changeLogStatusAndSendMail got error:${error}`;
        });
};

export const setShareSituation = (shareSituation) => (dispatch, getState) => {
    const token = getState().profile.jwt;
    const query = '/api/v1/cacaAoTesouro/setShareSituation';
    const data = { shareSituation };

    return Api.post(query, data, token)
        .then((json) => {
            if (json.status === 'success') {
                return Promise.resolve(1);
            }

            throw `error from server: ${json.message}`;
        }).catch((error) => {
            throw `setShareSituation got error:${error}`;
        });
};
